import adminAPI from '../util/AdminApi';
import {
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  HIDE_MESSAGE,
  SHOW_MESSAGE,
  COMMON_INIT,
  ON_PATCH_RESPONSE,
  ON_PUT_RESPONSE,
  DENOMINATIONS_LIST,
  OFFICERS_LIST,
  BANKS_LIST,
  CENTERS_LIST,
  BANKS_BRANCHES_LIST
} from "../constants/ActionTypes";

import {
  USER_ACTIVE_STATUS
} from "../constants/Common";


export const fetchStart = () => {
  return {
    type: FETCH_START
  }
};

export const fetchSuccess = () => {
  return {
    type: FETCH_SUCCESS
  }
};

export const fetchError = (error) => {
  return {
    type: FETCH_ERROR,
    payload: error
  }
};

export const showMessage = (message) => {
  return {
    type: SHOW_MESSAGE,
    payload: message
  }
};

export const hideMessage = () => {
  return {
    type: HIDE_MESSAGE
  }
};

export const initCommon = () => {
  return {
    type: COMMON_INIT
  }
};

export const patchResponse = (response) => {
  return {
    type: ON_PATCH_RESPONSE,
    response: response
  }
};

export const putResponse = (response) => {
  return {
    type: ON_PUT_RESPONSE,
    response: response
  }
};

export const getDenominationsList = () => {
  //Get denominations list from Admin API
  let token = sessionStorage.getItem('token');

  const _data = {
    headers: {
      Authorization: `Bearer ${token}`,
    }
    // data: {}
  };
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    adminAPI.get('denomination', _data,
    ).then(({ data }) => {
      if (data.length) {
        dispatch({ type: FETCH_SUCCESS });
        // format data and store them for use..
        dispatch({ type: DENOMINATIONS_LIST, payload: data.filter(x => x.IS_ACTIVE === 'Y') });
      } else {
        dispatch({ type: FETCH_ERROR, payload: data.error });
      }
    }).catch((error) => {
      dispatch({ type: FETCH_ERROR, payload: error.message });
    });
  }
}

export const getSafeCustodyCentersList = () => {
  //Get custody list from Admin API
  let token = sessionStorage.getItem('token');

  const _data = {
    headers: {
      Authorization: `Bearer ${token}`,
    }
    // data: {}
  };
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    adminAPI.get('safecustodycenters', _data,
    ).then(({ data }) => {
      if (data.length) {
        dispatch({ type: FETCH_SUCCESS });
        // format data and store them for use..
        dispatch({ type: CENTERS_LIST, payload: data });
      } else {
        dispatch({ type: FETCH_ERROR, payload: data.error });
      }
    }).catch((error) => {
      dispatch({ type: FETCH_ERROR, payload: error.message });
    });
  }
  //

  // let lst = [
  //   {
  //     "ID": 1,
  //     "CUSTODY_CENTER_NAME": "NBC Morogoro",
  //     "REGION_ID": 1,
  //     "BRANCH_CODE": "1",
  //     "CREATED_AT": "2020-03-17T15:19:51.000Z",
  //     "CREATED_BY": 1,
  //     "UPDATED_AT": null,
  //     "UPDATED_BY": 0,
  //     "CB_BRANCHES_SERVING": "[{\"ID\":284,\"BRANCH_CODE\":\"003\",\"BANK_CODE\":\"BK0020\",\"BRANCH_NAME\":\"DODOMA\",\"ACCT_NO\":null,\"REGION_ID\":3,\"SCC_ID\":1}]",
  //     "SCC_STOCK_BALANCE": "[]"
  //   },
  //   {
  //     "ID": 2,
  //     "CUSTODY_CENTER_NAME": "NMB Mkwawa",
  //     "REGION_ID": 2,
  //     "BRANCH_CODE": "2",
  //     "CREATED_AT": "2020-03-17T15:21:29.000Z",
  //     "CREATED_BY": 1,
  //     "UPDATED_AT": null,
  //     "UPDATED_BY": 0,
  //     "CB_BRANCHES_SERVING": "[{\"ID\":2,\"BRANCH_CODE\":\"002\",\"BANK_CODE\":\"001\",\"BRANCH_NAME\":\"MBEYA\",\"ACCT_NO\":null,\"REGION_ID\":4,\"SCC_ID\":2}]",
  //     "SCC_STOCK_BALANCE": "[]"
  //   }
  // ]

  // return (dispatch) => {
  //   dispatch({ type: CENTERS_LIST, payload: lst });
  // }

}

export const getBanksBranchList = (params = null) => {

  let token = sessionStorage.getItem('token');

  const _data = {
    // params: params,
    headers: {
      Authorization: `Bearer ${token}`,
    }
    // data: {}
  };

  //Get branches list from Admin API
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    adminAPI.get('bankbranch', _data
    ).then(({ data }) => {
      if (data.length) {
        dispatch({ type: FETCH_SUCCESS });
        // format data and store them for use..
        dispatch({ type: BANKS_BRANCHES_LIST, payload: data });
      } else {
        dispatch({ type: FETCH_ERROR, payload: 'data.error ' });
      }
    }).catch((error) => {
      dispatch({ type: FETCH_ERROR, payload: error.message });
    });
  }
}

export const getBankList = (params = null) => {
  //Get denominations list from Admin API

  let token = sessionStorage.getItem('token');

  const _data = {
    params: params,
    headers: {
      Authorization: `Bearer ${token}`,
    }
    // data: {}
  };
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    adminAPI.get('bank', _data,
    ).then(({ data }) => {
      if (data.length) {
        dispatch({ type: FETCH_SUCCESS });
        // format data and store them for use..
        dispatch({ type: BANKS_LIST, payload: data });
      } else {
        dispatch({ type: FETCH_ERROR, payload: data.error });
      }
    }).catch((error) => {
      dispatch({ type: FETCH_ERROR, payload: error.message });
    });
  }
}



export const getOfficersList = (branch_code = null, bank_code = null, custody_center_id = null, status = USER_ACTIVE_STATUS, serpervisory = null, role_id = null, nopics = false) => {
  //Get users list from Admin API

  let params = { 'TYPE': 'SPC' };
  params = (branch_code) ? { ...params, 'BRANCH_CODE': branch_code } : params;
  params = (bank_code) ? { ...params, 'BANK_CODE': bank_code } : params;
  params = (custody_center_id) ? { ...params, 'SCC_ID': custody_center_id } : params;
  params = (role_id) ? { ...params, 'ROLE_ID': role_id } : params;
  params = (status) ? { ...params, 'STATUS': status } : params;
  params = (serpervisory) ? { ...params, 'SUPERVISORY_BRANCH': serpervisory } : params;
  params = (nopics) ? { ...params, 'NOPICS': 1 } : params;

  let token = sessionStorage.getItem('token');

  const _data = {
    params: params,
    headers: {
      Authorization: `Bearer ${token}`,
    }
  };
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    //let endPoint = "users".concat((branch_code !== null) ? "?BRANCH_CODE=" + branch_code : "");
    adminAPI.get('users', _data
    ).then(({ data }) => {
      if (data.length) {
        dispatch({ type: FETCH_SUCCESS });
        // format data and store them for use..
        dispatch({ type: OFFICERS_LIST, payload: data });
      } else {
        dispatch({ type: FETCH_ERROR, payload: data.error });
      }
    }).catch((error) => {
      dispatch({ type: FETCH_ERROR, payload: error.message });
    });
  }
}






